import { Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { TabPanel } from "../../../components/Tabs/TabPannel";
import { breadcrumbAction } from "../../../redux/actions/config.action";
import { getAllDiscounts } from "../../../redux/actions/discount.action";
import { getAllCollections } from "../../../redux/actions/collections.action";
import AllDiscounts from "./AllDiscounts";
import "../../../static/css/productCss/allProduct.css";

function a11yProps(index) {
  return {
    id: `discount-tab-${index}`,
    "aria-controls": `discount-tabpanel-${index}`,
  };
}

function DiscountListing() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [tabIndex, setTabIndex] = useState(0);
  const [stats, setStats] = useState({
    active: 0,
    scheduled: 0,
    expired: 0,
    collections_on_discount: 0,
    total: 0,
  });
  const [totalCollections, setTotalCollections] = useState(0);

  useEffect(() => {
    dispatch(
      breadcrumbAction([
        { label: "Products", url: "/products/all-products" },
        { label: "Discounts", url: null },
      ])
    );

    dispatch(getAllDiscounts()).then((res) => {
      const body = res?.data;
      if (body?.stats) {
        const total =
          (body.stats.active || 0) +
          (body.stats.scheduled || 0) +
          (body.stats.expired || 0);
        setStats({ ...body.stats, total });
      }
    });

    dispatch(getAllCollections({ limit: 1, offset: 0 })).then((res) => {
      if (res?.data?.status === 200) {
        setTotalCollections(res.data.count || 0);
      }
    });
  }, [dispatch]);

  const statusByTab = ["", "active", "scheduled", "expired"];

  const statCards = [
    { label: "Active", value: stats.active },
    { label: "Scheduled", value: stats.scheduled },
    { label: "Expired", value: stats.expired },
    {
      label: "Collections on Discount",
      value: `${stats.collections_on_discount} / ${totalCollections}`,
    },
  ];

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="px-2 py-3 mb-3 card">
          <div className="px-2 py-3 bg-body bg-white rounded shadow-sm">
            <span>OVERVIEW</span>
            <div className="py-3 row">
              {statCards.map((card) => (
                <div key={card.label} className="col-3">
                  <div className="card p-4 border overview-card rounded">
                    <p className="m-0 text-muted p-0 input-inside-text">
                      {card.label}
                    </p>
                    <h4>{card.value}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="px-2 py-3 mb-3 card">
          <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span>DISCOUNT LISTING</span>
            <button
              type="button"
              className="btn btn-dark btn-sm px-3"
              onClick={() => history.push("/products/discounts/add")}
            >
              + Add Discount
            </button>
          </div>
          <div className="border card my-3">
            <Tabs
              value={tabIndex}
              onChange={(e, value) => setTabIndex(value)}
              variant="scrollable"
              orientation="horizontal"
              scrollButtons={false}
              className="px-3"
              aria-label="discount status tabs"
            >
              <Tab label={`All(${stats.total || 0})`} {...a11yProps(0)} />
              <Tab label={`Active(${stats.active || 0})`} {...a11yProps(1)} />
              <Tab label={`Scheduled(${stats.scheduled || 0})`} {...a11yProps(2)} />
              <Tab label={`Expired(${stats.expired || 0})`} {...a11yProps(3)} />
            </Tabs>
            {statusByTab.map((status, index) => (
              <TabPanel key={status || "all"} value={tabIndex} index={index}>
                <AllDiscounts status={status} setStats={setStats} />
              </TabPanel>
            ))}
          </div>
        </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default DiscountListing;
